import * as React from 'react'

const SvgArrowHorizontalIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.131 14.619l-2.237-2.244H15.5v-1.25H2.894L5.13 8.881 4.25 8 .5 11.75l3.75 3.75.881-.881zM15.5 4.25L11.75.5l-.881.881 2.237 2.244H.5v1.25h12.606L10.87 7.119 11.75 8l3.75-3.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgArrowHorizontalIcon
